// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RFvE","left":"styles_left__3Tr1_"};